import { Icon, cn, type IconName } from "@sagot/ui";

/** 48px rounded icon tile above auth headings (mail, shield-check, key, lock…). */
export function IconBadge({ icon, tone = "primary" }: { icon: IconName; tone?: "primary" | "success" }) {
  return (
    <span
      className={cn(
        "inline-flex size-12 items-center justify-center rounded-lg",
        tone === "success" ? "bg-success-soft text-success" : "bg-primary-soft text-primary-ink",
      )}
    >
      <Icon name={icon} className="size-6" />
    </span>
  );
}
